export const DEFAULT = "default";
export const GRANTED = "granted";
export const DENIED = "denied";
